import React, { useEffect, useState } from 'react';
import styles from './keycianecruz.module.scss';
import perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';

const EMAIL = 'keycianecruz.pro@gmail.com';
const INSTAGRAM_URL =
    'https://www.instagram.com/keycianecruz?stkn=MWZyZ3U2ZjlnZ2E4ZQ%3D%3D&utm_source=qr';
const TIKTOK_URL = 'https://www.tiktok.com/@keycianecruz?_r=1&_t=ZS-9AGBeJTaYyr';
const SHOPEE_URL = 'https://br.shp.ee/ks70irwm?fromSource=copy_link&smtt=0.0.9';
const GLOWMODE_URL = 'https://onelink.shein.com/55/641i015vr0uk?shc=2_RkMEnhVSFAw';
const GLOWMODE_CUPOM = 'CruzGM08';
const ICON_COLOR = '#621927';

type EmailCard = {
    id: number;
    image: string;
    alt: string;
    modal: 'email';
};

type CupomCard = {
    id: number;
    image: string;
    alt: string;
    cupom: string;
    site: string;
    modal: 'cupom';
};

type LinkCard = {
    id: number;
    image: string;
    alt: string;
    link: string;
    modal?: false;
};

type CardItem = EmailCard | CupomCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        alt: 'TikTok',
        link: TIKTOK_URL,
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        alt: 'Instagram',
        link: INSTAGRAM_URL,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        alt: 'Shopee',
        link: SHOPEE_URL,
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        alt: 'E-mail',
        modal: 'email',
    },
    {
        id: 5,
        image: require('./src/cards/5.png'),
        alt: 'GLOWMODE',
        cupom: GLOWMODE_CUPOM,
        site: GLOWMODE_URL,
        modal: 'cupom',
    },
];

const Keycianecruz: React.FC = () => {
    const [openModal, setOpenModal] = useState<'email' | 'cupom' | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!openModal) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setOpenModal(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [openModal]);

    useEffect(() => {
        setCopied(false);
    }, [openModal]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(GLOWMODE_CUPOM);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className={styles.keycianecruz}>
            <div className={styles.container}>
                <img src={perfil} alt="Keyciane Cruz" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a href={`mailto:${EMAIL}`} className={styles.socialLink} aria-label="E-mail">
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="22" color={ICON_COLOR} />
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setOpenModal(card.modal)}
                                aria-label={`Abrir ${card.alt}`}
                            >
                                <img src={card.image} alt={card.alt} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={card.alt} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {openModal ? (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setOpenModal(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="keycianecruz-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setOpenModal(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        {openModal === 'email' ? (
                            <>
                                <p className={styles.modalEyebrow}>Contato</p>
                                <h2 id="keycianecruz-modal-title" className={styles.modalBrand}>
                                    E-mail
                                </h2>
                                <div className={styles.contactActions}>
                                    <a href={`mailto:${EMAIL}`} className={styles.contactBtnEmail}>
                                        <svg
                                            height="22"
                                            width="22"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                            />
                                        </svg>
                                        <span>Enviar e-mail</span>
                                    </a>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className={styles.modalEyebrow}>Cupom exclusivo</p>
                                <h2 id="keycianecruz-modal-title" className={styles.modalBrand}>
                                    GLOWMODE
                                </h2>
                                <div className={styles.cupomBox}>
                                    <span className={styles.cupomLabel}>Seu cupom</span>
                                    <span className={styles.cupomCode}>{GLOWMODE_CUPOM}</span>
                                    <button
                                        type="button"
                                        className={styles.copyBtn}
                                        onClick={handleCopy}
                                    >
                                        {copied ? 'Copiado' : 'Copiar cupom'}
                                    </button>
                                </div>
                                <a
                                    href={GLOWMODE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.siteBtn}
                                >
                                    Ir para o site
                                </a>
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Keycianecruz;
